import { useElements, useStripe } from '@stripe/react-stripe-js'
import classNames from 'classnames'
import SuccessPaymentModal from 'containers/rechargeContainer/successPaymentModal'
import React, { useContext, useEffect, useRef, useState } from 'react'
import verifiedbyvisamastercard from '../../assets/verifiedbyvisamastercard.svg'
import verifiedbyvisa from '../../assets/verifiedbyvisa.svg'
import paimentFactureContext from 'contexts/paimentFactureContext'
import IconCarte from '../../assets/iconCarteBancaire.svg'
import IconCalendrier from '../../assets/iconCalendrier.svg'

interface props {
  clientSecret: string
  handleConfirmPayment: any
  functionTracks: any
  // ProviderCode: any
  // isTopnet: any
  // isSteg: any
  // isSoned: any
}

const PaiementForm: React.FC<props> = ({
  clientSecret,
  handleConfirmPayment,
  functionTracks,
  // ProviderCode,
  // isTopnet,
  // isSteg,
  // isSoned,
}) => {
  const elements = useElements()
  const stripe = useStripe()

  const cardNumberRef = useRef<HTMLInputElement>(null)
  const cardExpiryRef = useRef<HTMLInputElement>(null)
  const cardCvcRef = useRef<HTMLInputElement>(null)

  const [cardNumberElement, setCardNumberElement] = useState<any>(null)
  const [cardExpiryElement, setCardExpiryElement] = useState<any>(null)
  const [cardCvcElement, setCardCvcElement] = useState<any>(null)
  const { paimentFacture } = useContext(paimentFactureContext)

  const [successPayment, setSuccessPayment] = useState('')
  const [openModalSuccessPayment, setOpenModalSuccessPayment] = useState(false)

  const [isButtonClicked, setIsButtonClicked] = useState(false)

  const [countStatus, setCountStatus] = useState(1)
  const [countNbClick, setCountNbClick] = useState(1)
  const [isInvoices,setIsInvoices]= useState('')
 

  const closeModalSuccessPayment = () => {
    setOpenModalSuccessPayment(false)
  }

   const [cardComplete, setCardComplete] = useState({
        number: false,
        expiry: false,
        cvc: false,
      })

        const style ={
    base:{
      color:'#5754E5',
       '::placeholder': {
        color: '#D1D1FF', 
      },
      
    }
  }
 
  // useEffect(() => {
  //   if (!stripe || !elements) {
  //     return
  //   }
    

  //   const cardNumberElement = elements.create('cardNumber')
  //   const cardExpiryElement = elements.create('cardExpiry')
  //   const cardCvcElement = elements.create('cardCvc')

  //   if (cardNumberRef.current) {
  //     cardNumberElement.mount(cardNumberRef.current)
  //   }

  //   if (cardExpiryRef.current) {
  //     cardExpiryElement.mount(cardExpiryRef.current)
  //   }

  //   if (cardCvcRef.current) {
  //     cardCvcElement.mount(cardCvcRef.current)
  //   }

  //   setCardNumberElement(cardNumberElement)
  //   setCardExpiryElement(cardExpiryElement)
  //   setCardCvcElement(cardCvcElement)

  //   cardNumberElement.update({ placeholder: 'Numéro de carte' })
  //   cardExpiryElement.update({ placeholder: 'Date' })
  //   cardCvcElement.update({ placeholder: 'CVC' })

  //   return () => {
  //     cardNumberElement.destroy()
  //     cardExpiryElement.destroy()
  //     cardCvcElement.destroy()
  //   }
  // }, [stripe, elements])
 


   useEffect(() => {
      if (!stripe || !elements) {
        return
      }
  
      const cardNumberElement = elements.create('cardNumber', { style ,  placeholder: 'Numéro de carte',})
      const cardExpiryElement = elements.create('cardExpiry', { style ,  placeholder: 'Date d’expiration - mm/aaaa',})
      const cardCvcElement = elements.create('cardCvc', { style ,  placeholder: 'CVC',})

      // setCardNumberElement ( elements.create('cardNumber', { style ,  placeholder: 'Numéro de carte',}))
      // setCardExpiryElement ( elements.create('cardExpiry', { style ,  placeholder: 'Date d’expiration - mm/aaaa',}))
      // setCardCvcElement ( elements.create('cardCvc', { style ,  placeholder: 'CVC',}))
  
      if (cardNumberRef.current) {
        cardNumberElement.mount(cardNumberRef.current)
      }
  
      if (cardExpiryRef.current) {
        cardExpiryElement.mount(cardExpiryRef.current)
      }
  
      if (cardCvcRef.current) {
        cardCvcElement.mount(cardCvcRef.current)
      }
      cardNumberElement.on('change', (event: any) => {
        setCardComplete((prev) => ({ ...prev, number: event.complete }))
      })
  
      cardExpiryElement.on('change', (event: any) => {
        setCardComplete((prev) => ({ ...prev, expiry: event.complete }))
      })
      cardCvcElement.on('change', (event: any) => {
        setCardComplete((prev) => ({ ...prev, cvc: event.complete }))
      })
  
      setCardNumberElement(cardNumberElement)
      setCardExpiryElement(cardExpiryElement)
      setCardCvcElement(cardCvcElement)
  
    
      return () => {
        cardNumberElement.destroy()
        cardExpiryElement.destroy()
        cardCvcElement.destroy()
      }
    }, [stripe, elements])
  

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    if (!stripe || !elements || !cardNumberElement) {
      return
    }
    setIsButtonClicked(false)

    const { paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardNumberElement,
      },
    })
    //functionTracks('3')

    setSuccessPayment(`${paymentIntent?.status}`)

    // if (successPayment === 'undefined') {
    //   setCountStatus(countStatus + 1)
    //   setCountNbClick(countNbClick + 1)
    //   if (countStatus === 2 && countNbClick === 2) {
    //     setIsButtonClicked(true)
    //     setOpenModalSuccessPayment(true)
    //   }
    // }

    if (paymentIntent?.status === 'succeeded') {
      handleConfirmPayment()
      setIsButtonClicked(true)
      setIsInvoices('facture')
      setOpenModalSuccessPayment(true)
      // setPaimentFacture({})
    } else {
      setCountStatus(countStatus + 1)
      setCountNbClick(countNbClick + 1)
      if (countStatus === 2 && countNbClick === 2) {
        setIsButtonClicked(true)
        setOpenModalSuccessPayment(true)
      }
    }
  }

  return (
    <div>

    <form className="w-full flex flex-col gap-8  items-center justify-center  " onSubmit={handleSubmit} id="payment-form"  autoComplete="off">
      <h1 className='h2'>Payez avec votre carte en toute sécurité</h1>
          <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[56px] rounded-[16px] border border-[#AEB6FB]">
           <img src={IconCarte} width={24} height={24} alt=''/>
            <div
              id="card-number"
              ref={cardNumberRef}
              className=" w-full"
            ></div>
          </div>
    

        <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[56px] rounded-[16px] border border-[#AEB6FB]">
           <img src={IconCalendrier} width={24} height={24} alt=''/>
            <div
              id="card-expiry"
              ref={cardExpiryRef}
              className=" w-full"
            ></div>
          </div>
        

         <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[56px] rounded-[16px] border border-[#AEB6FB]">
            <div
              id="card-cvc"
              ref={cardCvcRef}
              className="w-full"
            ></div>
          </div>
       
          <button
            className={classNames(
              `text-[18px] font-semibold text-[#FFF] w-full h-[56px] rounded-[16px]
                  ${!(cardComplete.cvc && cardComplete.expiry && cardComplete.number) ? 'bg-[#D1D1FF] ' : 'bg-[#5754E5]'}
                  `,
            )}
            disabled={!(cardComplete.cvc && cardComplete.expiry && cardComplete.number)}
          >
            Payer <span className="pl-3 "> {Number(paimentFacture?.amountToPay).toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })}  EUR</span>
          </button>

        <p className="text-center text-[14px]  text-[#6B7280] sm:w-full  w-[550px]">
          Selon votre établissement bancaire, vous pourrez être redirigé vers la
           page d&rsquo;authentification de votre
          banque avant la validation de votre paiement.<br/>
        </p>
        <div className="text-center text-[14px] text-[#6B7280]">
         Sécurisé par :
        </div>
        <div className="flex justify-center items-center">
          <img src={verifiedbyvisamastercard} className="w-32 h-32 " />
          <img src={verifiedbyvisa} className="w-32 h-32" />
        </div>
      </form>  
      
      {successPayment !== '' && (
        <SuccessPaymentModal
          isOpen={openModalSuccessPayment}
          closeModal={closeModalSuccessPayment}
          successPayment={successPayment}
          isInvoices={isInvoices}
        />
      )}
    </div>
  )
}

export default PaiementForm
